import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";

// get customers

export const getMappingListApi = createAsyncThunk("client/get-mappingMiddleware-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}admin/mappingMiddleware/api/v1/get-mappingMiddleware-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of maping list", response);
    return response;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

//get count
export const getMappingCountApi = createAsyncThunk("client/mappingMiddleware-count", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}admin/mappingMiddleware/api/v1/mappingMiddleware-count`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of maping list", response);
    return response;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

// import data for

export const importMappingMiddlewareApi = createAsyncThunk("client/import-csv-files", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}import-csv-router/api/v2/import-csv-files`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of maping list", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

//  update mappingMiddleware
export const updateMappingMiddlewareApi = createAsyncThunk("client/update-mappingMiddleware", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}admin/mappingMiddleware/api/v1/update-mappingMiddleware/${data.ROWID}`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response  update of maping list", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

// delete mappingMiddleware
export const deleteMappingMiddlewareApi = createAsyncThunk("client/delete-mappingMiddleware", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}admin/mappingMiddleware/api/v1/delete-mappingMiddleware/${data}`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of maping list", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

// CRATEA MAPLIST
export const createMappingMiddlewareApi = createAsyncThunk("client/create-mappingMiddleware", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}admin/mappingMiddleware/api/v1/create-mappingMiddleware`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of maping list", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});
